import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const CtaBanner = () => (
  <section data-testid="cta-banner" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8 }}
        className="bg-black rounded-3xl px-8 py-16 md:px-16 md:py-24 text-center"
      >
        <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">Partner With Us</p>
        <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-tight font-bold text-[#F5F5F7] max-w-2xl mx-auto">
          Serve the sky at your table.
        </h2>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-[#86868B] max-w-xl mx-auto">
          From luxury hospitality to premium retail — join the establishments serving the
          world's purest, most thoughtfully crafted hydration.
        </p>
        <Link
          to="/contact"
          data-testid="cta-banner-link"
          className="mt-10 inline-block px-8 py-4 rounded-full bg-[#F5F5F7] text-[#1D1D1F] text-sm font-medium hover:bg-white active:scale-95 transition-[background-color,transform] duration-200"
        >
          Start a Conversation
        </Link>
      </motion.div>
    </div>
  </section>
);
